import { DragEventHandler } from "react";
import { useThemeProvider } from "@albo-ui/core";
import { Box, Divider, Card, CardContent } from "@mui/material";
import { DragCard } from "./DragCard";

const ColumnBoard = ({
    funnelKey,
    listIndex,
    sectionData,
    count,
    property,
    setDragged,
    cardDropped,
    cardProps,
    cardType,
    children
}: any) => {
    const { theme } = useThemeProvider();

    const handleDrop: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        cardDropped(listIndex);
    };

    const allowDrop: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
    };

    const renderCard = () => {
        return sectionData.map((item, i) => {
            return funnelKey === item[property] &&
            <DragCard key={i} item={item} dragAction={setDragged} cardType={cardType} cardProps={cardProps} />
        })
    }

    return (
        <Card key={funnelKey} style={{minWidth: 250, padding: 12, margin: 10, borderRadius: 10, backgroundColor: theme.colors.iconLightGrayBackground, borderColor: theme.colors.manatee}}>
            <CardContent sx={{ height: "100%" }}>
                <Box display={"grid"}>{children}</Box>
                <Divider sx={{ my: 2 }} />
                <Box
                    onDrop={handleDrop} onDragOver={allowDrop} onDragEnter={allowDrop}
                    sx={{minHeight: sectionData.length > 0 && 250, maxHeight: 360, overflowY: "auto", scrollbarWidth: "thin", "&::-webkit-scrollbar": { width: "0.4em" },}}>
                    {sectionData.length > 0 && count > 0 ? renderCard() : "Sin resultados"}
                </Box>
            </CardContent>
        </Card>
    );
};

export default ColumnBoard;
